import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StarRatingDisplayProps {
  rating: number
  size?: 'sm' | 'md'
}

export function StarRatingDisplay({ rating, size = 'md' }: StarRatingDisplayProps) {
  const starSize = size === 'sm' ? 'size-3.5' : 'size-5'

  return (
    <div className="flex items-center gap-0.5" aria-label={`${rating} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          className={cn(
            starSize,
            star <= rating
              ? 'fill-brand-orange stroke-brand-orange'
              : 'fill-transparent stroke-muted-foreground/40'
          )}
        />
      ))}
    </div>
  )
}
